// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"32":"HomeView","68":"business","545":"aboutMe","557":"share","895":"download"}[chunkId] || chunkId) + "." + {"32":"2ea0885e","68":"36f50954","545":"637c422c","547":"0f16b610","557":"7c045565","629":"d1ef403d","895":"61b69b4a","911":"72e4d0a3"}[chunkId] + ".js";
};